import { render, staticRenderFns } from "./DetailChart.vue?vue&type=template&id=4ae601fe&scoped=true"
import script from "./DetailChart.vue?vue&type=script&lang=js"
export * from "./DetailChart.vue?vue&type=script&lang=js"
import style0 from "./DetailChart.vue?vue&type=style&index=0&id=4ae601fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae601fe",
  null
  
)

export default component.exports